import { RootState } from '@reducers';

export const selectInsurancePolicyUserDetails = (state: RootState) =>
  state.userDashboardRouteReducer.insurancePolicyUserDetailsPageReducer;
